<ng-container>

	<google-map [class]="Class" [id]="id" [options]="Options" [center]="Options?.center"
		style="height: 100% !important;">

		<map-marker #markerElem="mapMarker" *ngFor="let marker of Markers" [position]="marker.position"
			[label]="marker.label" [title]="marker?.title" [options]="marker?.options"
			(mapDragend)="OnDrag($event, marker)" (mapClick)="OnOpenInfo(markerElem, marker.info)">
		</map-marker>

		<map-circle *ngFor="let c of Circles"
			[center]="{ lat: c.lat, lng: c.lng }"
			[radius]="c.radius"
			[options]="{ fillColor: c.color || '#00365B', fillOpacity: 0.28, strokeColor: c.color || '#00365B', strokeOpacity: 0.7, strokeWeight: 1, clickable: false }">
		</map-circle>

		<map-kml-layer #kmlLayer="mapKmlLayer" [hidden]="!PolygonUrl" [url]="PolygonUrl">
		</map-kml-layer>

		<!-- <map-info-window>{{ infoContent }}</map-info-window> -->
	</google-map>

</ng-container>